import { all, call, put, takeLatest } from '@redux-saga/core/effects';
import envConfig from '../../../config';
import { request } from '../../../common/util/RestClient';
import {
  fetchVendorObjectProperties,
  createTicketFieldMapping,
  createDeduplicationMapping,
  fetchTicketFieldMapping,
  fetchDeduplicationMapping,
  fetchIntegrationContextStatus,
  saveIngrationContextStatus,
} from '../../routines/integrations/supportIntegrationRoutines';
import { INTEGRATION_TYPE } from '../../../common/constants/IntegrationConstants';
import {
  COMMON_SYNC_DIRECTION,
  SYNC_DIRECTION,
} from '../../../common/constants/integrationConstants/crmConstants';
import { INTERCOM_SUCCESS_MESSAGE } from '../../../common/constants/integrationConstants/supportConstants';

function* fetchAllPropertiesSaga(action) {
  try {
    const { vendor, type } = action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/properties?vendor=${vendor}&type=${type}`;
    const { data } = yield call(request, url);
    yield put(fetchVendorObjectProperties.success({ ...data }));
  } catch (error) {
    yield put(fetchVendorObjectProperties.failure({ error }));
  }
}

function* fetchEntityFieldMappingsSaga(action) {
  try {
    const { vendor, type } = action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/entity/configs/mapping?vendor=${vendor}&type=${type}`;
    const { data } = yield call(request, url);
    const { deduplication } = data;
    yield put(fetchDeduplicationMapping.success(deduplication));
  } catch (error) {
    yield put(fetchDeduplicationMapping.failure({ error }));
  }
}

function* fetchTicketFieldMappingSaga(action) {
  try {
    const { vendor, type } = action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/ticket/configs/mapping?vendor=${vendor}&type=${type}`;
    const { data } = yield call(request, url);
    yield put(fetchTicketFieldMapping.success(data));
  } catch (error) {
    yield put(fetchTicketFieldMapping.failure({ error }));
  }
}

function* saveTicketFieldMappingSaga(action) {
  try {
    const { vendor, type, mapping, fieldMappingType } = action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/ticket/configs/mapping?vendor=${vendor}&type=${type}`;
    const config = {
      method: 'POST',
      payload: {
        mapping,
        fieldMappingType,
      },
    };
    const { data } = yield call(request, url, config);
    yield put(
      createTicketFieldMapping.success({
        ...data,
        successMessage: 'Intercom configuration successfully saved',
      })
    );
  } catch (error) {
    yield put(createTicketFieldMapping.failure({ error }));
  }
}

function* saveTicketDeduplicationMappingSaga(action) {
  try {
    const { vendor, type, entity, mapping, criteria, fieldMappingType } =
      action.payload;
    const url = `${envConfig.APIG_URL}field-mapping/entity/configs/mapping?vendor=${vendor}&type=${type}`;
    const config = {
      method: 'POST',
      payload: {
        entity,
        mapping,
        criteria,
        fieldMappingType,
      },
    };
    const { data } = yield call(request, url, config);
    yield put(
      createDeduplicationMapping.success({
        ...data,
        successMessage: 'Intercom configuration successfully saved',
      })
    );
  } catch (error) {
    yield put(createDeduplicationMapping.failure({ error }));
  }
}
function* saveIngrationContextStatusSaga(action) {
  try {
    const {
      enable,
      type,
      vendor,
      syncDirection,
      criteria,
      syncType,
      settingType,
      entityLevel,
    } = action.payload;
    const url = `${envConfig.APIG_URL}integration/integration-context`;
    const direction =
      syncDirection === SYNC_DIRECTION.OUT
        ? COMMON_SYNC_DIRECTION.OUT
        : COMMON_SYNC_DIRECTION.IN;

    const config = {
      method: 'PUT',
      payload: {
        integrationConfigs: [
          {
            syncDirection: direction,
            integrationType: type,
            settingType,
            syncType,
            vendor,
            entityLevel,
            criteria,
            enable,
          },
        ],
      },
    };

    yield call(request, url, config);
    yield put(
      saveIngrationContextStatus.success({
        entityLevel,
        settingType,
        criteria,
        syncType,
        enable,
        successMessage: `${INTERCOM_SUCCESS_MESSAGE}`,
      })
    );
  } catch (error) {
    yield put(saveIngrationContextStatus.failure({ error }));
  } finally {
    yield put(saveIngrationContextStatus.fulfill());
  }
}

function* fetchIngrationContextStatusSaga(action) {
  const { vendor } = action.payload;
  try {
    const url = `${envConfig.APIG_URL}integration/integration-context?vendor=${vendor}&integrationType=${INTEGRATION_TYPE.SUPPORT}`;
    const { data } = yield call(request, url);
    yield put(
      fetchIntegrationContextStatus.success({
        ...data,
      })
    );
  } catch (error) {
    yield put(fetchIntegrationContextStatus.failure({ error }));
  }
}
export default function* root() {
  yield all([
    takeLatest(fetchVendorObjectProperties.TRIGGER, fetchAllPropertiesSaga),
    takeLatest(createTicketFieldMapping.TRIGGER, saveTicketFieldMappingSaga),
    takeLatest(
      createDeduplicationMapping.TRIGGER,
      saveTicketDeduplicationMappingSaga
    ),
    takeLatest(fetchDeduplicationMapping.TRIGGER, fetchEntityFieldMappingsSaga),
    takeLatest(fetchTicketFieldMapping.TRIGGER, fetchTicketFieldMappingSaga),
    takeLatest(
      fetchIntegrationContextStatus.TRIGGER,
      fetchIngrationContextStatusSaga
    ),
    takeLatest(
      saveIngrationContextStatus.TRIGGER,
      saveIngrationContextStatusSaga
    ),
  ]);
}
